import {useState} from 'react';
import {loadStripe} from '@stripe/stripe-js/pure';
import {collection, addDoc, onSnapshot} from 'firebase/firestore';

import Constant from 'utils/Constant';
import firestore, {Collection} from 'services/DatabaseService';
import useAuth from 'hooks/useAuth'; 
import { IPlan } from './useStaticContent';

const useSubscribe = () => {
  const [state, setState] = useState<{
    isSubscribing: boolean;
    error: string | null;
  }>({
    isSubscribing: false,
    error: null,
  });
  const {user} = useAuth();

  const subscribe = async (plan: IPlan) => {
    const uid = user?.uid;
    if (!uid) {
      return;
    }
    setState({isSubscribing: true, error: null});
    const stripe = await loadStripe(Constant.stripePublicKey);
    const rootRef = collection(
      firestore,
      `${Collection.User}/${uid}/${Collection.Checkout}`
    );

    // Create a new session for checkout.
    const docRef = await addDoc(rootRef, {
      price: plan.id,
      success_url: window.location.origin + `?status=success`,
      cancel_url: window.location.origin + `?status=failed`,
      allow_promotion_codes: true,
      metadata: {
        cmsId: plan.cmsId,
        title: plan.title,
      }
    });

    const unsubscribe = onSnapshot(docRef, (snap) => {
      const {error, sessionId} = snap.data() as {
        error: string | null;
        sessionId: string | null;
      };
      if (sessionId) {
        stripe?.redirectToCheckout({
          sessionId,
        });
        unsubscribe();
        setState({isSubscribing: false, error});
      } else if (error) {
        unsubscribe();
        setState({isSubscribing: false, error});
      }
    });
  };
  return {subscribe, state};
};

export default useSubscribe;
